const imageAudio = "_35si113rr1u";
const content = "_35sc1lagii6";
const image = "_35si13ogjom";

export { content, image, imageAudio };
import "./tile.image.style.linaria.module.css";
//# sourceMappingURL=tile.image.style.js.map
